import Login from "./pages/base/Login";
import Logout from "./pages/base/Logout";
import { createDesignSystem } from '@qastanfit/qastan-ui';
import DesignSystem from "./styles/DesignSystem.json";
import { Routes, Route, Navigate } from "react-router-dom";
// import ResetPassword from "./pages/base/ResetPassword";
// import Register from "./pages/base/Register";

import { setDefaultOptions } from "date-fns";
import { nlBE } from "date-fns/locale";
import Admin from "./pages/base/Admin";
import PortalRoutes from "./pages/base/PortalRoutes";
import EncryptedString from "./pages/PublicDocument";
import RequireAuth from "./context/RequireAuth";
import useAuth from "./hooks/useAuth";
import PersistLogin from "./context/PersistLogin";
import PublicDoc from "./pages/public-document";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { nl, fr, enUS } from "date-fns/locale";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { TooltipProvider } from "./components/ui/tooltip";

library.add(fas, far, fab)

createDesignSystem(DesignSystem);
setDefaultOptions({ locale: nlBE })

function App() {
  const { t, i18n } = useTranslation()
  const {auth} = useAuth()

  useEffect(()=>{
    switch (i18n.language) {
      case 'nl':
        setDefaultOptions({ locale: nl})
        break;
      case 'fr':
        setDefaultOptions({ locale: fr})
        break;
      case 'en':
          setDefaultOptions({ locale: enUS})
          break;
      default:
        setDefaultOptions({ locale: enUS})
        break;
    }
  }, [i18n.language])
  
  if(auth.status === 'unauthenticated') {
    console.error("Unauthenticated")
    localStorage.clear();;
    return (
      <Navigate to="/login" replace/>
    )
  }

  return (
    <>
    <TooltipProvider>
      <Routes>

          <Route path="login" element={<Login />}/>
          {/* <Route path="registreren" element={<Register />}/>
          <Route path="paswoord-herstellen" element={<ResetPassword />}/> */}
          <Route path="logout" element={<Logout />} />
          
          <Route path="admin/*" element={<Admin />}/>
          {/* <Route path="document" element={<EncryptedString />}/> */}
          <Route path="document" element={<PublicDoc />} />
          <Route path="demo-document" element={<PublicDoc />} />


          <Route element={<PersistLogin/>}>
            <Route element={<RequireAuth />}>
              <Route path="*" element={<PortalRoutes />}/>
            </Route>
          </Route>
      </Routes>
    </TooltipProvider>
    </>
  );
}

export default App;
